import { useState } from "react";
import { NavLink } from "react-router-dom";

const NavBar = () => {
  const [showParent, setShowParent] = useState(false);
  return (
    <section className="navbar">
      <div className="container">
        <div className="large">
          <div className="nav-contents flex">
            <div className="brand-part">
              <a href="/home">
                <img
                  src="https://res.cloudinary.com/malidad/image/upload/v1779680532/ntuna_2026_logo_36_c8hccz.png"
                  className="nav-logo"
                  alt="NTUNA.COM Logo"
                />
                <p className="boldTitle">
                  NTUNA.COM <sup>&trade;</sup>
                </p>
              </a>
            </div>
            <div className="nav-part">
              <nav className="nav relative" role="navigation">
                <label
                  onClick={() => setShowParent(true)}
                  htmlFor="toggle-responsive-menu"
                  className="nav-label bold-title"
                >
                  <img
                    src="https://res.cloudinary.com/malidad/image/upload/v1777961231/bars_sejohc.svg"
                    alt="Menu"
                  />
                </label>
                <input type="checkbox" id="toggle-responsive-menu" />
                <div
                  onClose={() => setShowParent(false)}
                  showParent={showParent}
                  className={`menu-inner ${showParent ? "showParent" : ""}`}
                >
                  <div className="hide-menu">
                    <button
                      onClick={() => setShowParent(false)}
                      className="hide-menu-btn button"
                    >
                      <img
                        src="https://res.cloudinary.com/malidad/image/upload/v1777961231/close_ssv9ew.svg"
                        alt="Close Menu"
                      />
                    </button>
                  </div>
                  <ul className="menu" onClick={() => setShowParent(false)}>
                    <li>
                      <NavLink
                        to="/home"
                        className={({ isActive }) =>
                          isActive ? "active" : " "
                        }
                      >
                        Home
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to="/about"
                        className={({ isActive }) =>
                          isActive ? "active" : " "
                        }
                      >
                        About
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to="/solutions"
                        className={({ isActive }) =>
                          isActive ? "active" : " "
                        }
                      >
                        Solutions
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to="/industries"
                        className={({ isActive }) =>
                          isActive ? "active" : " "
                        }
                      >
                        Industries
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to="/case-studies"
                        className={({ isActive }) =>
                          isActive ? "active" : " "
                        }
                      >
                        Case Studies
                      </NavLink>
                    </li>
                  </ul>
                </div>
              </nav>
              <div className="cta-part flex">
                <div className="cta-part-contact">
                  <div className="cta-part-contact-item cta-part-contact-link">
                    <a href="/contacts">Global Contacts &rarr;</a>
                  </div>
                  <div className="cta-part-contact-item cta-part-contact-phones boldTitle">
                    <span>Call: </span>
                    <a href="tel:+256702096666"> +256-702-096-666</a>
                  </div>
                </div>
                <div className="cta-part-quotation">
                  <a
                    href="https://form.jotform.com/ntuna/get-free-quote"
                    className="button nav-cta"
                  >
                    Get Free Quote
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NavBar;
